import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { EventPipelineService } from '@bootstrap/services/event-pipeline.service';
import { ApplicationReady, EventName } from '@itero/itero-client-communication';
import { TlkLoadingSpinnerComponent } from '@itero/ui-toolkit-angular/loading-spinner';
import { EmbeddedRemoteApplicationComponent } from '@itero/ui-toolkit-angular/remote-application';
import { BaseDestroyableComponent } from '@shared/base-classes/base-destroyable';
import { ImplantsViewAppParameter } from '@shared/implants-view/models/implants-view-app-parameter';
import { ImplantsViewAppId } from '@shared/models/consts';
import { takeUntil } from 'rxjs/operators';

@Component({
	selector: 'rx-implants-view',
	templateUrl: './implants-view.component.html',
	styleUrls: ['./implants-view.component.scss'],
	standalone: true,
	imports: [CommonModule, EmbeddedRemoteApplicationComponent, TlkLoadingSpinnerComponent]
})
export class ImplantsViewComponent extends BaseDestroyableComponent implements OnInit {
	@Input() appParameters: ImplantsViewAppParameter;

	readonly appId = ImplantsViewAppId;

	appLoaded = false;

	constructor(
		private readonly eventPipelineService: EventPipelineService,
		private readonly cdr: ChangeDetectorRef
	) {
		super();
	}

	ngOnInit(): void {
		this.eventPipelineService
			.fromEvent<ApplicationReady>(EventName.appReady)
			.pipe(takeUntil(this.componentAlive$))
			.subscribe(data => {
				if (data.eventHeader.publisher === this.appId) {
					this.appLoaded = true;
					this.cdr.markForCheck();
				}
			});
	}
}
